"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.badge = void 0;
const _ = __importStar(require("lodash"));
const helpers_1 = require("../helpers");
const DOT_HTML = '<span class="pr-1"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16"><circle cx="8" cy="8" r="4" fill="currentColor"/></svg></span>';
function badge(opts) {
    if (!opts) {
        throw new TypeError('Options is required.');
    }
    const pill = opts.pill ? 'badge-pill ' : '';
    function getVariant(value, fieldValue) {
        let result = '';
        if (opts.variantmap) {
            result =
                opts.variantmap[opts.variantMapSource === 'fieldValue' ? fieldValue : value];
        }
        if (!result && opts.variant) {
            result = opts.variant;
        }
        if (result) {
            result = `badge-${result}`;
        }
        return result;
    }
    function getBadgeClass(row, value) {
        if (_.isString(opts.badgeClass)) {
            return opts.badgeClass;
        }
        if (_.isFunction(opts.badgeClass)) {
            return opts.badgeClass(row, value);
        }
    }
    function getClassNames(value, fieldValue, data) {
        return _.chain([
            getVariant(value, fieldValue),
            getBadgeClass(data, value),
            pill,
            opts.dot ? 'badge-dot' : null
        ])
            .filter(p => !!p)
            .join(' ')
            .value();
    }
    const badgeFormatter = (row, cell, value, columnDef, data) => {
        if (value == null)
            return '';
        const field = columnDef.field;
        (0, helpers_1.assertNonNullish)(field, 'ColumnDefinition.field must have a value.');
        const classNames = getClassNames(value, _.get(data, field, null), data);
        const dotHTML = opts.dot ? DOT_HTML : '';
        return `<span class="badge ${classNames}">${dotHTML}${value}</span>`;
    };
    badgeFormatter.exportRawData = true;
    return badgeFormatter;
}
exports.badge = badge;
//# sourceMappingURL=badge.js.map